import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MessageService} from '../shared/services/message.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (![401/*, 403*/].includes(err.status)) {
        console.log(err);
        const message = err?.error?.error ? err.error.error.message : '';
        this.messageService.showMessage(message, 'error');
      }
      return throwError(err);
    }));
  }
}
